export enum ReviewType {
  BACKGROUND = 'background',
  CREDIT = 'credit'
}